import React, { useEffect, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getObjectValue } from '../../helpers/general';

function CustomerNameSurname({ index, text,  value, validate, onChange }) {
  const { t, i18n } = useTranslation();
  const [localName, setLocalName] = useState(value ? value : "");
  const [showNameInputError, setShowNameInputError] = useState(false);

  useEffect(() => {
    if(index && getObjectValue(validate, index) === false) {
      setShowNameInputError(true);
    } else {
      setShowNameInputError(false);
    }
  }, [index, validate]);
  

  const handleNameChange = (value) => {
    setLocalName(value);
    onChange?.(index, value);
  };

  return (<>
    <input
      type="text"
      className="form-control"
      placeholder={t(text)}
      tabIndex="0"
      value={localName}
      onChange={(event) => handleNameChange(event.target.value)}
    />
    <div className="editMe-fieldValidation">
      {showNameInputError && <span>{t("review.error.rf")}</span>}
    </div>
  </>);
}

export default CustomerNameSurname;
